export const validateString = (str: string, validPattern?: RegExp): boolean => !!validPattern && validPattern.test(str);
